import { render } from "./EditSecteurActivitePage.vue?vue&type=template&id=3f8a7073&ts=true"
import script from "./EditSecteurActivitePage.vue?vue&type=script&lang=ts"
export * from "./EditSecteurActivitePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__